export const LangTexts = {
  en: {
    error: 'An error has occurred. Please try again later. ( if you have AdBlock ou AntiTracking (Ghostery) Disabled it and reload )',
    notFoundTop: 'No movies that match the criteria.',
    notFoundBottom: 'Please search for something else.',
  },
  'pt-BR': {
    error: 'Ocorreu um erro. Por favor, tente novamente mais tarde. ( Se tiver AdBlock ou AntiTracking (Ghostery) Desative e Recarregue )',
    notFoundTop: 'Não foi encontrado Filmes com esse critério.',
    notFoundBottom: 'Por favor pesquise por outros.',
  },
};
